<template>
  <ul class="list-group list-group-flush tx-13">
    <li
      class="list-group-item d-flex pd-sm-x-20"
      v-for="(t, i) in tasks"
      :key="i"
    >
      <div class="avatar d-none d-sm-block">
        <span v-if="t.i1 == 0" class="avatar-initial rounded-circle bg-gray-500"
          ><feather type="shopping-bag" class="ht-20-f wd-20-f"></feather
        ></span>
        <span
          v-else-if="t.i1 == 1"
          class="avatar-initial rounded-circle bg-teal"
          ><feather type="check-square" class="ht-20-f wd-20-f"></feather
        ></span>
        <span
          v-else-if="t.i1 == -1"
          class="avatar-initial rounded-circle bg-danger"
          ><feather type="eye-off" class="ht-20-f wd-20-f"></feather
        ></span>
        <span v-else class="avatar-initial rounded-circle bg-warning"
          ><feather type="square" class="ht-20-f wd-20-f"></feather
        ></span>
      </div>
      <div class="pd-sm-l-10">
        <p class="tx-medium mg-b-0">{{ t.task }}</p>
        <small class="tx-12 tx-color-03 mg-b-0">{{
          t.createdDate | moment("YYYY.MM.DD HH:mm, dddd")
        }}</small>
      </div>
      <div class="mg-l-auto text-right">
        <p class="tx-medium mg-b-0">{{ t.organizationTask.task }}</p>
        <button
          v-if="t.i1 == 0"
          @click="$emit('on-cancel-order', t)"
          class="btn btn-xs btn-uppercase btn-outline-light mg-t-5"
        >
          Цуцлах
        </button>
        <span v-else-if="t.i1 == -1" class="badge badge-danger mg-t-5" disabled
          >Цуцлагдсан</span
        >
        <span v-else-if="t.i1 == 1" class="badge badge-success mg-t-5" disabled
          >баталгаажсан</span
        >
        <span
          v-else-if="t.i1 == 2"
          class="badge badge-secondary mg-t-5"
          disabled
          >буцааж өгсөн</span
        >
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style></style>
